import {
  Alert,
  Col,
  Collapse,
  message,
  Modal,
  notification,
  PageHeader,
  Row,
  Select,
  Spin,
  Table,
  Tag,
  Typography,
  Upload,
} from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import moment from "moment";
import * as XLSX from "xlsx";
import { DownloadOutlined, LinkOutlined, PlusOutlined, UploadOutlined } from "@ant-design/icons";
import {
  ButtonItem,
  DatePickerItem,
  dineroDisabledMask,
  Form,
  FormItem,
  InputItem,
  InputNumberItem,
  SelectItem,
  TextAreaItem,
} from "../../../../Components/Items";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import ModalInsumoParaCliente from "../../../../Components/ModalInsumoParaCliente";
import ModalAltaInsumoImss from "./ModalAltaInsumoImss";
import ModalConfirmarPedidosImss from "./ModalConfirmarPedidosImss";
import {
  analizarLibro,
  DIAS_SEMANA,
  elegirHojaMatriz,
  extraerPedidoIMSS,
  leerArchivoExcel,
  MXN,
  volcarEnConsola,
} from "./parseoExcelIMSS";
import { agregarTotalesPedido, calcularPartida, obtenerPrecioUnitario } from "./calculosPedidoIMSS";

const { Option } = Select;
const { Text } = Typography;
const { Panel } = Collapse;

// Encabezados de la plantilla fija; no es un formato libre.
const COLUMNAS_PLANTILLA = [
  "LOTE",
  "C.B.A",
  "NOMBRE DEL ALIMENTO",
  "PRESENTACION",
  "MENSUAL",
  "LUNES",
  "MARTES",
  "MIERCOLES",
  "JUEVES",
  "VIERNES",
  "SABADO",
  "DOMINGO",
];

const descargarPlantilla = () => {
  const hoja = XLSX.utils.aoa_to_sheet([COLUMNAS_PLANTILLA]);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, hoja, "Pedido IMSS");
  XLSX.writeFile(workbook, "plantillaPedidoIMSS.xlsx");
};

const capitalizar = (texto) => texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase();

// Antepone el dia a la leyenda general, ej. "Lunes: ..."
const observacionPorDefecto = (nombreDia, leyenda) => {
  const dia = capitalizar(nombreDia);
  return leyenda ? `${dia}: ${leyenda}` : dia;
};

class ImportarPedidosIMSS extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    guardando: false,
    archivosExcel: [],
    analisis: null,
    extraccion: null,
    resoluciones: null,
    clienteSeleccionado: null,
    propuesta: [],
    noResueltas: [],
    diasSeleccionados: [],
    fechasPorDia: {},
    observacionesPorDia: {},
    // Lineas quitadas a mano (ej. las que quedaron en $0); clave "dia:filaExcel"
    lineasExcluidas: {},
    resultados: null,
    ponerVendedor: false,
    ponerMetodoDePago: false,
    todasUsuarios: [],
    objetoProyectos: [],
    deshabilitarBancoDefault: false,
    todasPrecios: [],
    objetoPrecios: [],
    objetoUsosDeCFDI: [],
    objetoUsuarios: [],
    objetoMonedas: [],
    objetoCanalesVenta: [],
    insumoIdsCliente: [],
    modalVincularVisible: false,
    modalAltaVisible: false,
    filaAccion: null,
    modalConfirmarVisible: false,
    valoresPedido: null,
  };

  componentDidMount() {
    this.consultarTodo();
  }

  atras() {
    this.props.history.goBack();
  }

  consultarTodo() {
    this.setState({ loading: true });
    axios
      .post(
        "pedidos/selectDatosParaPedido",
        { empresaId: this.props.empresaId, cotizacionesSeleccionadas: [] },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.status === 404) return;
        this.setState({
          ponerVendedor: res.data.ponerVendedor,
          ponerMetodoDePago: res.data.ponerMetodoDePago,
          deshabilitarBancoDefault: res.data.deshabilitarBanco || false,
          todasUsuarios: res.data.usuariosEmpresa || [],
          objetoProyectos: (res.data.proyectos || []).map((value) => (
            <Option value={value._id} key={value._id}>
              {value.nombre}
            </Option>
          )),
          todasPrecios: res.data.precios || [],
          objetoPrecios: (res.data.precios || []).map((value) => (
            <Option value={value._id} key={value._id}>
              {value.nombre}
            </Option>
          )),
          objetoUsosDeCFDI: (res.data.usosDeCFDI || []).map((value) => (
            <Option value={value._id} key={value._id}>
              {value?.c_UsoCFDI + " - " + value.descripcion}
            </Option>
          )),
          objetoUsuarios: (res.data.usuariosEmpresa || []).map((value) => (
            <Option value={value._id} key={value._id}>
              {value.nombre + " " + value.apellidoPaterno + " " + value.apellidoMaterno}
            </Option>
          )),
          objetoMonedas: (res.data.monedas || []).map((value) => (
            <Option value={value._id} key={value._id}>
              {value.nombre + " - " + value.abreviacion}
            </Option>
          )),
          objetoCanalesVenta: (res.data.canalesVenta || []).map((value) => (
            <Option value={value._id} key={value._id}>
              {value.nombre}
            </Option>
          )),
        });
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("No se pudieron cargar los datos para el pedido");
      });
  }

  onChangeCliente(valueId, cliente) {
    if (!cliente) return;
    if (!this.props.insumosXClienteEmpresa) {
      message.error('La empresa no tiene activado "Insumos por Cliente". Actívalo en Configuración > Complementos antes de importar pedidos.');
      this.formRef.current.setFieldsValue({ clienteId: undefined });
      this.setState({ clienteSeleccionado: null });
      return;
    }
    if (!cliente.insumosXCliente) {
      message.error(
        'Este cliente no tiene activado "Insumos por Cliente". Actívalo en Clientes > Editar Cliente > pestaña Insumos antes de importarle pedidos.'
      );
      this.formRef.current.setFieldsValue({ clienteId: undefined });
      this.setState({ clienteSeleccionado: null });
      return;
    }

    let contado = this.formRef.current.getFieldValue("contado");
    const objetoCambiar = {};
    if (cliente.usoDeCFDIID) objetoCambiar.usoDeCfdiId = cliente.usoDeCFDIID;
    if (cliente.contado && this.state.ponerMetodoDePago) {
      objetoCambiar.contado = cliente.contado;
      contado = cliente.contado;
      message.info("Se actualizo el metodo de pago");
    }
    if (cliente.precioContadoId || cliente.precioCreditoId) {
      objetoCambiar.precioId = contado === 1 ? cliente.precioContadoId : cliente.precioCreditoId;
    } else if (this.state.todasPrecios[0]) {
      // Cliente sin lista de precios configurada: se usa la primera de la empresa para que
      // los insumos sin precio propio en Insumos por Cliente no se queden en $0
      objetoCambiar.precioId = this.state.todasPrecios[0]._id;
    }
    if (cliente.proyectoId) objetoCambiar.proyectoId = cliente.proyectoId;
    if (
      cliente.vendedorId &&
      this.state.ponerVendedor &&
      this.state.todasUsuarios.find((u) => u._id?.toString() === cliente.vendedorId?.toString())
    ) {
      objetoCambiar.vendedorId = cliente.vendedorId;
    }
    if (cliente.monedaId) {
      objetoCambiar.monedaId = cliente.monedaId;
      this.onChangeMoneda(cliente.monedaId);
    }
    this.formRef.current.setFieldsValue({ diasCredito: cliente.diasCredito || 0, ...objetoCambiar });

    this.setState({ clienteSeleccionado: cliente }, () => {
      if (this.state.extraccion?.ok) this.resolverInsumos();
      this.cargarInsumoIdsCliente();
    });
  }

  // Insumos ya vinculados a este cliente, para no ofrecerlos de nuevo en "Vincular a insumo existente"
  cargarInsumoIdsCliente() {
    const clienteId = this.state.clienteSeleccionado?._id;
    if (!clienteId) return;
    axios
      .post(
        "insumosCliente/selectInsumoIdsCliente",
        { empresaId: this.props.empresaId, clienteId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) this.setState({ insumoIdsCliente: res.data.insumoIds });
      });
  }

  onChangeMoneda(value) {
    if (!value || value === MXN) {
      this.formRef.current.setFieldsValue({ tipoDeCambio: 1 });
      return;
    }
    axios
      .post(
        "tipoDeCambio/obtenerTipoDeCambio",
        { monedaId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.formRef.current.setFieldsValue({ tipoDeCambio: res.data.tipoDeCambio });
          this.construirPropuesta();
        }
      });
  }

  async onChangeArchivo(e) {
    const file = e.file.originFileObj || e.file;
    if (!/\.xlsx?$/i.test(file.name || "")) {
      message.error("El archivo debe ser un Excel (.xlsx o .xls)");
      return;
    }
    this.setState({
      loading: true,
      archivosExcel: [{ ...e.file, name: file.name, status: "uploading", response: "Cargando" }],
      analisis: null,
      extraccion: null,
      resoluciones: null,
      propuesta: [],
      noResueltas: [],
      resultados: null,
    });
    try {
      const workbook = await leerArchivoExcel(file);
      const analisis = analizarLibro(workbook, file.name);
      const hoja = analisis.hojas[elegirHojaMatriz(analisis)];
      const extraccion = extraerPedidoIMSS(hoja);
      volcarEnConsola(analisis, extraccion);

      this.setState(
        {
          loading: false,
          analisis,
          extraccion,
          archivosExcel: [{ ...e.file, name: file.name, status: "success" }],
        },
        () => {
          if (!extraccion.ok) {
            message.error(extraccion.motivo);
            return;
          }
          if (extraccion.partidas.length === 0) {
            message.warning(
              'El archivo se leyo pero no trajo renglones con cantidad (ni en dias ni en MENSUAL). Revisa que la plantilla este llena.'
            );
            return;
          }
          message.success(
            `Se leyeron ${extraccion.partidas.length} renglones de la hoja "${extraccion.hoja}"`
          );
          if (!this.formRef.current.getFieldValue("observaciones")) {
            this.formRef.current.setFieldsValue({
              observaciones: `Pedido generado a partir del archivo "${file.name}"`,
            });
          }
          if (this.state.clienteSeleccionado) this.resolverInsumos();
        }
      );
    } catch (error) {
      console.log(error);
      this.setState({
        loading: false,
        archivosExcel: [{ ...e.file, name: file.name, status: "error", response: "Error" }],
      });
      message.error("No se pudo leer el archivo. Verifica que sea un Excel valido.");
    }
  }

  resolverInsumos() {
    const { extraccion, clienteSeleccionado } = this.state;
    if (!extraccion?.ok || !clienteSeleccionado) return;
    if (extraccion.partidas.length === 0) {
      this.setState({ resoluciones: [], propuesta: [], noResueltas: [] });
      return;
    }

    this.setState({ loading: true });
    axios
      .post(
        "insumosCliente/resolverInsumosClienteMasivo",
        {
          empresaId: this.props.empresaId,
          clienteId: clienteSeleccionado._id,
          filas: extraccion.partidas.map((partida) => ({
            clave: partida.clave,
            nombre: partida.nombre,
          })),
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          message.error(res.data.message || "No se pudieron resolver los insumos del cliente");
          this.setState({ resoluciones: null, propuesta: [], noResueltas: [] });
          return;
        }
        this.setState({ resoluciones: res.data.resultados }, this.construirPropuesta);
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("No se pudieron resolver los insumos del cliente");
      });
  }

  construirPropuesta = () => {
    const { extraccion, resoluciones, clienteSeleccionado, fechasPorDia, observacionesPorDia, lineasExcluidas } =
      this.state;
    if (!extraccion?.ok || !resoluciones) return;

    const values = this.formRef.current.getFieldsValue();
    const tipoDeCambio = values.tipoDeCambio || 1;
    const fechaLunes = values.fechaLunes;

    const noResueltas = [];
    extraccion.partidas.forEach((partida, indice) => {
      const resolucion = resoluciones[indice];
      if (resolucion?.estado === "ENCONTRADO") return;
      const totalPorFecha = partida.cantidadesPorFecha.reduce((suma, item) => suma + item.cantidad, 0);
      noResueltas.push({
        key: indice,
        fila: partida.fila,
        clave: partida.clave,
        nombre: partida.nombre,
        presentacion: partida.presentacion,
        estado: resolucion?.estado || "NO_ENCONTRADO",
        motivo: resolucion?.motivo,
        candidatos: resolucion?.candidatos || [],
        cantidades: partida.cantidades,
        cantidadMensual: partida.cantidadMensual,
        cantidadesPorFecha: partida.cantidadesPorFecha,
        totalCantidad:
          Object.values(partida.cantidades).reduce((suma, item) => suma + item, 0) +
          (partida.cantidadMensual || 0) +
          totalPorFecha,
      });
    });

    const armarLinea = (partida, indice, cantidad, diaKey) => {
      if (lineasExcluidas[`${diaKey}:${partida.fila}`]) return null;

      const resolucion = resoluciones[indice];
      if (resolucion?.estado !== "ENCONTRADO") return null;

      const insumo = resolucion.insumo;
      const precioUnitario = obtenerPrecioUnitario(insumo, values.precioId);
      const calculo = calcularPartida({ insumo, cliente: clienteSeleccionado, precioUnitario, cantidad, tipoDeCambio });

      return {
        ...calculo,
        insumoId: insumo._id,
        proyectoId: values.proyectoId,
        vistaClave: insumo.clave,
        vistaDescripcion: insumo.nombreClienteAlternativo || insumo.descripcion,
        vistaUnidad: insumo.unidad,
        vistaFilaExcel: partida.fila,
        vistaSinCodigoSat: !insumo.codigoSat,
      };
    };

    const pedidosPorDia = DIAS_SEMANA.map((diaSemana) => {
      const lineas = [];
      extraccion.partidas.forEach((partida, indice) => {
        const cantidad = partida.cantidades[diaSemana.dia];
        if (!cantidad) return;
        const linea = armarLinea(partida, indice, cantidad, diaSemana.dia);
        if (linea) lineas.push(linea);
      });

      const fecha =
        fechasPorDia[diaSemana.dia] ||
        (fechaLunes ? moment(fechaLunes).add(diaSemana.dia - 1, "days") : null);

      return {
        key: diaSemana.dia,
        dia: diaSemana.dia,
        nombreDia: diaSemana.nombre,
        fecha,
        observacionesPedido:
          observacionesPorDia[diaSemana.dia] ?? observacionPorDefecto(diaSemana.nombre, values.observaciones),
        lineas,
        totales: agregarTotalesPedido(lineas),
      };
    }).filter((dia) => dia.lineas.length > 0);

    const lineasMensuales = [];
    extraccion.partidas.forEach((partida, indice) => {
      if (!partida.cantidadMensual) return;
      const linea = armarLinea(partida, indice, partida.cantidadMensual, "mensual");
      if (linea) lineasMensuales.push(linea);
    });
    const pedidoMensual =
      lineasMensuales.length === 0
        ? []
        : [
            {
              key: "mensual",
              dia: "mensual",
              nombreDia: "Pedido mensual",
              fecha: fechasPorDia.mensual || null,
              observacionesPedido: observacionesPorDia.mensual ?? values.observaciones,
              lineas: lineasMensuales,
              totales: agregarTotalesPedido(lineasMensuales),
            },
          ];

    const porFecha = new Map();
    extraccion.partidas.forEach((partida, indice) => {
      partida.cantidadesPorFecha.forEach(({ fecha, cantidad }) => {
        const diaKey = moment(fecha).format("YYYY-MM-DD");
        const linea = armarLinea(partida, indice, cantidad, diaKey);
        if (!linea) return;
        // El DatePicker truena con la fecha como Date nativo (date.clone is not a function)
        if (!porFecha.has(diaKey)) porFecha.set(diaKey, { diaKey, fecha: moment(fecha), lineas: [] });
        porFecha.get(diaKey).lineas.push(linea);
      });
    });
    const pedidosPorFecha = [...porFecha.values()]
      .sort((a, b) => a.fecha - b.fecha)
      .map(({ diaKey, fecha, lineas }) => {
        const nombreDia = moment(fecha).format("dddd D MMM");
        return {
          key: diaKey,
          dia: diaKey,
          nombreDia,
          fecha: fechasPorDia[diaKey] || fecha,
          observacionesPedido: observacionesPorDia[diaKey] ?? observacionPorDefecto(nombreDia, values.observaciones),
          lineas,
          totales: agregarTotalesPedido(lineas),
        };
      });

    const propuesta = [...pedidosPorDia, ...pedidoMensual, ...pedidosPorFecha];

    // Solo se reinicia la seleccion si cambian los dias propuestos, no en cada recalculo
    const diasPropuestos = propuesta.map((dia) => dia.dia);
    const mismosDias =
      diasPropuestos.length === this.diasPropuestosAnteriores?.length &&
      diasPropuestos.every((dia, i) => dia === this.diasPropuestosAnteriores[i]);
    this.diasPropuestosAnteriores = diasPropuestos;

    this.setState((prev) => ({
      propuesta,
      noResueltas,
      diasSeleccionados: mismosDias
        ? prev.diasSeleccionados.filter((dia) => diasPropuestos.includes(dia))
        : diasPropuestos,
    }));
  };

  onChangeFechaLunes() {
    this.setState({ fechasPorDia: {} }, this.construirPropuesta);
  }

  onChangeFechaDia(dia, fecha) {
    this.setState(
      (prev) => ({ fechasPorDia: { ...prev.fechasPorDia, [dia]: fecha } }),
      this.construirPropuesta
    );
  }

  // Se actualiza directo en la propuesta, sin recalcular todo en cada tecla
  onChangeObservacionesDia(dia, observaciones) {
    this.setState((prev) => ({
      observacionesPorDia: { ...prev.observacionesPorDia, [dia]: observaciones },
      propuesta: prev.propuesta.map((item) =>
        item.dia === dia ? { ...item, observacionesPedido: observaciones } : item
      ),
    }));
  }

  quitarLinea(dia, filaExcel) {
    this.setState(
      (prev) => ({ lineasExcluidas: { ...prev.lineasExcluidas, [`${dia}:${filaExcel}`]: true } }),
      this.construirPropuesta
    );
  }

  abrirVincular(registro) {
    this.setState({ modalVincularVisible: true, filaAccion: registro });
  }
  cerrarVincular() {
    this.setState({ modalVincularVisible: false, filaAccion: null });
  }
  guardarVinculo(valores) {
    const clienteId = this.state.clienteSeleccionado?._id;
    this.setState({ loading: true });
    axios
      .post(
        "insumosCliente/agregarInsumoPersonalizadoCliente",
        { empresaId: this.props.empresaId, clienteId, ...valores },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Insumo vinculado al cliente");
          this.cerrarVincular();
          this.cargarInsumoIdsCliente();
          this.resolverInsumos();
        } else {
          message.error(res.data.message || "No se pudo vincular el insumo");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("No se pudo vincular el insumo");
      });
  }

  abrirAlta(registro) {
    this.setState({ modalAltaVisible: true, filaAccion: registro });
  }
  cerrarAlta() {
    this.setState({ modalAltaVisible: false, filaAccion: null });
  }
  onAltaGuardada() {
    this.cerrarAlta();
    this.cargarInsumoIdsCliente();
    this.resolverInsumos();
  }

  elegirCandidato(registro, insumoClienteId) {
    const clienteId = this.state.clienteSeleccionado?._id;
    this.setState({ loading: true });
    axios
      .post(
        "insumosCliente/resolverInsumoClientePorId",
        { empresaId: this.props.empresaId, clienteId, insumoClienteId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          message.error(res.data.message || "No se pudo resolver el insumo elegido");
          return;
        }
        this.setState((prev) => {
          const resoluciones = [...prev.resoluciones];
          resoluciones[registro.key] = {
            clave: registro.clave,
            nombre: registro.nombre,
            estado: "ENCONTRADO",
            insumo: res.data.insumo,
            conversion: res.data.conversion,
          };
          return { resoluciones };
        }, this.construirPropuesta);
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("No se pudo resolver el insumo elegido");
      });
  }

  descargarNoResueltas() {
    const columnas = this.state.extraccion?.columnas || {};
    const diasEnUso = DIAS_SEMANA.filter((dia) => (columnas.dias || []).some((item) => item.dia === dia.dia));
    const hayMensual = columnas.mensual !== undefined && columnas.mensual !== -1;
    const fechasEnUso = [...(columnas.fechas || [])].sort((a, b) => a.fecha - b.fecha);

    const filas = this.state.noResueltas.map((item) => {
      const esAmbiguo = item.estado === "AMBIGUO";
      const fila = {
        "Fila del Excel": item.fila,
        Clave: item.clave,
        "Nombre en el Excel": item.nombre,
        "Unidad (Excel)": item.presentacion || "",
      };
      diasEnUso.forEach((dia) => {
        fila[dia.nombre] = item.cantidades[dia.dia] || 0;
      });
      if (hayMensual) fila.MENSUAL = item.cantidadMensual || 0;
      fechasEnUso.forEach((columnaFecha) => {
        const encontrada = item.cantidadesPorFecha.find(
          (valor) => moment(valor.fecha).format("YYYY-MM-DD") === moment(columnaFecha.fecha).format("YYYY-MM-DD")
        );
        fila[moment(columnaFecha.fecha).format("DD/MM/YYYY")] = encontrada?.cantidad || 0;
      });
      fila["Cantidad total"] = item.totalCantidad;
      fila.Estado = esAmbiguo ? "Ambiguo (mas de un insumo posible)" : "No encontrado";
      fila["Que hacer"] = esAmbiguo
        ? "Entra a Importar Pedidos y elige cual de los candidatos usar en el renglon."
        : "Entra a Importar Pedidos y vincula este renglon a un insumo existente o dalo de alta.";
      fila.Detalle = esAmbiguo
        ? (item.candidatos || [])
            .map((candidato) => `${candidato.clave || "s/clave"} - ${candidato.nombreAlternativo}`)
            .join("; ")
        : item.motivo || "No esta en Insumos por Cliente";
      return fila;
    });
    const hoja = XLSX.utils.json_to_sheet(filas);
    const anchoColumnasCantidad = diasEnUso.length + (hayMensual ? 1 : 0) + fechasEnUso.length;
    hoja["!cols"] = [
      { wch: 10 },
      { wch: 16 },
      { wch: 40 },
      { wch: 16 },
      ...Array(anchoColumnasCantidad).fill({ wch: 10 }),
      { wch: 14 },
      { wch: 26 },
      { wch: 50 },
      { wch: 50 },
    ];
    const libro = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(libro, hoja, "Sin resolver");
    XLSX.writeFile(libro, "renglonesSinResolver.xlsx");
  }

  onFinishFailed() {
    message.error("Revisa que los datos sean correctos");
  }

  onFinish(values) {
    const dias = this.state.propuesta.filter((dia) =>
      this.state.diasSeleccionados.includes(dia.dia)
    );
    if (dias.length === 0) return message.warning("Selecciona al menos un dia para importar");
    if (dias.some((dia) => dia.dia !== "mensual" && !dia.fecha)) {
      return message.warning("Falta la fecha de entrega de alguno de los dias seleccionados");
    }

    if (this.state.noResueltas.length > 0) {
      Modal.confirm({
        title: "Quedan renglones sin relacionar",
        content: `${this.state.noResueltas.length} renglon(es) del Excel no se pudieron empatar con ningun insumo y NO se van a incluir en los pedidos. ¿Deseas continuar y crear los pedidos de todas formas?`,
        okText: "Si, crear de todas formas",
        cancelText: "Cancelar",
        onOk: () => this.abrirModalConfirmar(values),
      });
      return;
    }

    this.abrirModalConfirmar(values);
  }

  abrirModalConfirmar(values) {
    this.setState({ modalConfirmarVisible: true, valoresPedido: values });
  }

  cerrarModalConfirmar() {
    this.setState({ modalConfirmarVisible: false, valoresPedido: null });
  }

  confirmarYCrearPedidos() {
    const dias = this.state.propuesta.filter((dia) => this.state.diasSeleccionados.includes(dia.dia));
    if (dias.some((dia) => dia.dia !== "mensual" && !dia.fecha)) {
      message.warning("Falta la fecha de entrega de alguno de los dias seleccionados");
      return;
    }
    const valoresPedido = this.state.valoresPedido;
    this.setState({ modalConfirmarVisible: false, valoresPedido: null });
    this.crearPedidos(valoresPedido, dias);
  }

  async crearPedidos(values, dias) {
    const { fechaLunes, archivo, observaciones, ...datosGenerales } = values;

    this.setState({ guardando: true, resultados: null });
    const resultados = [];

    for (const dia of dias) {
      const insumos = dia.lineas.map((linea) => ({
        insumoId: linea.insumoId,
        proyectoId: linea.proyectoId,
        precioUnitario: linea.precioUnitario,
        precioUnitarioConImpuestos: linea.precioUnitarioConImpuestos,
        cantidad: linea.cantidad,
        descuento: linea.descuento,
        descuentoCantidad: linea.descuentoCantidad,
        subtotal: linea.subtotal,
        impuestos: linea.impuestos,
        arrayImpuestos: linea.arrayImpuestos,
        retenciones: linea.retenciones,
        arrayRetenciones: linea.arrayRetenciones,
        total: linea.total,
        observaciones: linea.observaciones,
      }));

      try {
        // eslint-disable-next-line no-await-in-loop
        const res = await axios.post(
          "pedidos/agregarPedido",
          {
            ...datosGenerales,
            observaciones: dia.observacionesPedido,
            fechaEntregaEstimada: dia.fecha || null,
            semana: dia.fecha ? moment(dia.fecha).isoWeek() : undefined,
            insumos,
            empresaId: this.props.empresaId,
            cotizacionesSeleccionadas: [],
            archivoOrdenDeCompra: null,
            deshabilitarBanco: this.state.deshabilitarBancoDefault,
            ...dia.totales,
            apartarDisponible: false,
          },
          { headers: this.props.headersToken }
        );

        if (res.data.success === 2) {
          resultados.push({ ...dia, ok: true, pedidoId: res.data.pedidoId });
        } else {
          resultados.push({
            ...dia,
            ok: false,
            mensaje: [res.data.message, res.data.description].filter(Boolean).join(". "),
          });
        }
      } catch (error) {
        console.log(error);
        resultados.push({ ...dia, ok: false, mensaje: "Error de comunicacion con el servidor" });
      }
    }

    const creados = resultados.filter((item) => item.ok);
    const fallidos = resultados.filter((item) => !item.ok);

    if (fallidos.length === 0) {
      this.setState({ guardando: false, resultados });
      message.success(`Se crearon ${creados.length} pedido(s)`);
      this.atras();
      return;
    }

    this.setState((prev) => ({
      guardando: false,
      resultados,
      diasSeleccionados: prev.diasSeleccionados.filter(
        (dia) => !creados.some((item) => item.dia === dia)
      ),
    }));
    notification.warning({
      message: `Se crearon ${creados.length} de ${resultados.length} pedidos`,
      description: fallidos
        .map((item) => `${item.nombreDia}: ${item.mensaje || "no se pudo crear"}`)
        .join(" | "),
      duration: 0,
    });
  }

  columnasPropuesta() {
    return [
      { title: "Dia", dataIndex: "nombreDia", key: "nombreDia", width: 130 },
      {
        title: "Fecha de entrega",
        key: "fecha",
        width: 180,
        render: (_, registro) => (
          <DatePickerItem
            value={registro.fecha}
            placeholder={registro.fecha ? "Fecha" : "Sin fecha definida"}
            allowClear={registro.dia === "mensual"}
            onChange={(fecha) => this.onChangeFechaDia(registro.dia, fecha)}
          />
        ),
      },
      {
        title: "Observaciones",
        key: "observacionesPedido",
        width: 260,
        render: (_, registro) => (
          // El borde por defecto de InputItem se pierde dentro de la celda; se marca uno propio
          <div style={{ border: "1px solid #bfbfbf", borderRadius: 4, background: "#fff" }}>
            <InputItem
              sinBorde
              value={registro.observacionesPedido}
              placeholder="Observaciones de este pedido"
              onChange={(e) => this.onChangeObservacionesDia(registro.dia, e.target.value)}
            />
          </div>
        ),
      },
      {
        title: "Partidas",
        key: "partidas",
        width: 90,
        align: "right",
        render: (_, registro) => registro.lineas.length,
      },
      {
        title: "Subtotal",
        key: "subtotal",
        width: 130,
        align: "right",
        render: (_, registro) => dineroDisabledMask(registro.totales.subtotal),
      },
      {
        title: "Total",
        key: "total",
        width: 130,
        align: "right",
        render: (_, registro) => dineroDisabledMask(registro.totales.total),
      },
      {
        title: "Avisos",
        key: "avisos",
        render: (_, registro) => {
          const sinSat = registro.lineas.filter((linea) => linea.vistaSinCodigoSat).length;
          const sinPrecio = registro.lineas.filter((linea) => !linea.precioUnitario).length;
          if (!sinSat && !sinPrecio) return <Tag color="green">Listo</Tag>;
          return (
            <>
              {sinSat > 0 && <Tag color="red">{sinSat} sin codigo SAT</Tag>}
              {sinPrecio > 0 && <Tag color="orange">{sinPrecio} en $0</Tag>}
            </>
          );
        },
      },
    ];
  }

  columnasDetalle(diaKey) {
    return [
      { title: "Fila", dataIndex: "vistaFilaExcel", key: "vistaFilaExcel", width: 70 },
      { title: "Clave", dataIndex: "vistaClave", key: "vistaClave", width: 150 },
      { title: "Insumo", dataIndex: "vistaDescripcion", key: "vistaDescripcion" },
      { title: "Unidad", dataIndex: "vistaUnidad", key: "vistaUnidad", width: 110 },
      { title: "Cant.", dataIndex: "cantidad", key: "cantidad", width: 80, align: "right" },
      {
        title: "P. Unitario",
        dataIndex: "precioUnitario",
        key: "precioUnitario",
        width: 120,
        align: "right",
        render: (valor) => (valor ? dineroDisabledMask(valor) : <Tag color="orange">$0</Tag>),
      },
      {
        title: "Total",
        dataIndex: "total",
        key: "total",
        width: 120,
        align: "right",
        render: (valor) => dineroDisabledMask(valor),
      },
      {
        title: "",
        key: "acciones",
        width: 90,
        render: (_, registro) => (
          <ButtonItem
            rojo
            size="small"
            onClick={() => this.quitarLinea(diaKey, registro.vistaFilaExcel)}
          >
            Quitar
          </ButtonItem>
        ),
      },
    ];
  }

  renderResultados() {
    if (!this.state.resultados) return null;
    const creados = this.state.resultados.filter((item) => item.ok);
    const fallidos = this.state.resultados.filter((item) => !item.ok);
    if (fallidos.length === 0) return null;

    return (
      <Alert
        type="warning"
        showIcon
        style={{ marginTop: 10 }}
        message={`Se crearon ${creados.length} de ${this.state.resultados.length} pedidos`}
        description={
          <>
            {creados.length > 0 && (
              <div>
                <Text strong>Ya creados (destildados): </Text>
                {creados.map((item) => item.nombreDia).join(", ")}
              </div>
            )}
            <div>
              <Text strong>No se pudieron crear: </Text>
              {fallidos
                .map((item) => `${item.nombreDia} (${item.mensaje || "sin detalle"})`)
                .join(" | ")}
            </div>
          </>
        }
      />
    );
  }

  renderPropuesta() {
    const { extraccion, resoluciones, propuesta, noResueltas } = this.state;
    if (!extraccion) return null;

    if (!extraccion.ok) {
      return (
        <Alert
          type="error"
          showIcon
          style={{ marginTop: 10 }}
          message="No se pudo leer la orden de suministro"
          description={
            <>
              <p style={{ marginBottom: 10 }}>
                {extraccion.motivo} El contenido completo del archivo quedo en la consola del navegador (F12).
              </p>
              <ButtonItem size="small" icon={<DownloadOutlined />} onClick={descargarPlantilla}>
                Descargar plantilla
              </ButtonItem>
            </>
          }
        />
      );
    }

    if (!this.state.clienteSeleccionado) {
      return (
        <Alert
          type="warning"
          showIcon
          style={{ marginTop: 10 }}
          message="Falta elegir el cliente"
          description={`Se leyeron ${extraccion.partidas.length} renglones. Elige el cliente para empatarlos contra sus Insumos por Cliente.`}
        />
      );
    }

    if (!resoluciones) return null;

    const resueltas = extraccion.partidas.length - noResueltas.length;

    return (
      <>
        <Alert
          type={noResueltas.length > 0 ? "warning" : "success"}
          showIcon
          style={{ marginTop: 10 }}
          message={`Hoja "${extraccion.hoja}": ${extraccion.partidas.length} renglones con cantidad, ${resueltas} empatados con Insumos por Cliente${
            noResueltas.length > 0 ? `, ${noResueltas.length} sin empatar` : ""
          }`}
          description={
            noResueltas.length > 0
              ? "Los renglones sin empatar no se incluyen en ningun pedido. Resuelvelos aqui abajo o descargalos para configurarlos despues en Insumos por Cliente."
              : undefined
          }
        />

        {noResueltas.length > 0 && (
          <Collapse style={{ marginTop: 10 }}>
            <Panel
              header={`Renglones sin empatar (${noResueltas.length})`}
              key="noResueltas"
              extra={
                <ButtonItem
                  icon={<DownloadOutlined />}
                  onClick={(evento) => {
                    evento.stopPropagation();
                    this.descargarNoResueltas();
                  }}
                >
                  Descargar
                </ButtonItem>
              }
            >
              <Table
                size="small"
                rowKey="key"
                dataSource={noResueltas}
                pagination={{ pageSize: 10, showSizeChanger: false }}
                scroll={{ x: "max-content" }}
                columns={[
                  { title: "Fila", dataIndex: "fila", key: "fila", width: 70 },
                  { title: "Clave", dataIndex: "clave", key: "clave", width: 160 },
                  { title: "Nombre en el Excel", dataIndex: "nombre", key: "nombre" },
                  { title: "Unidad (Excel)", dataIndex: "presentacion", key: "presentacion", width: 150 },
                  {
                    title: "Estado",
                    key: "estado",
                    width: 220,
                    render: (_, registro) =>
                      registro.estado === "AMBIGUO" ? (
                        <Tag color="orange">Mas de un insumo con esa clave/nombre</Tag>
                      ) : (
                        <Tag color="red">{registro.motivo || "No esta en Insumos por Cliente"}</Tag>
                      ),
                  },
                  {
                    title: "Acciones",
                    key: "acciones",
                    width: 220,
                    render: (_, registro) =>
                      registro.estado === "AMBIGUO" ? (
                        <Select
                          placeholder="Elegir insumo"
                          style={{ width: "100%" }}
                          onChange={(insumoClienteId) => this.elegirCandidato(registro, insumoClienteId)}
                        >
                          {registro.candidatos.map((candidato) => (
                            <Option value={candidato.insumoClienteId} key={candidato.insumoClienteId}>
                              {(candidato.clave ? candidato.clave + " - " : "") + candidato.nombreAlternativo}
                            </Option>
                          ))}
                        </Select>
                      ) : (
                        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                          <ButtonItem
                            azul
                            size="small"
                            icon={<LinkOutlined />}
                            style={{ width: "100%" }}
                            onClick={() => this.abrirVincular(registro)}
                          >
                            Vincular existente
                          </ButtonItem>
                          <ButtonItem
                            naranja2
                            size="small"
                            icon={<PlusOutlined />}
                            style={{ width: "100%" }}
                            onClick={() => this.abrirAlta(registro)}
                          >
                            Dar de alta nuevo
                          </ButtonItem>
                        </div>
                      ),
                  },
                ]}
              />
            </Panel>
          </Collapse>
        )}

        {propuesta.length === 0 ? (
          <Alert
            type="error"
            showIcon
            style={{ marginTop: 10 }}
            message="No hay pedidos que proponer"
            description="Ningun renglon con cantidad se pudo empatar contra los Insumos por Cliente."
          />
        ) : (
          <>
            <Text strong style={{ display: "block", marginTop: 15, marginBottom: 5 }}>
              Pedidos propuestos
            </Text>
            <Table
              size="small"
              rowKey="key"
              dataSource={propuesta}
              columns={this.columnasPropuesta()}
              pagination={false}
              scroll={{ x: "max-content" }}
              rowSelection={{
                selectedRowKeys: this.state.diasSeleccionados,
                onChange: (diasSeleccionados) => this.setState({ diasSeleccionados }),
              }}
              expandable={{
                expandedRowRender: (registro) => (
                  <Table
                    size="small"
                    rowKey="vistaFilaExcel"
                    dataSource={registro.lineas}
                    columns={this.columnasDetalle(registro.dia)}
                    pagination={{ pageSize: 10, showSizeChanger: false }}
                    scroll={{ x: "max-content" }}
                  />
                ),
              }}
            />
          </>
        )}
      </>
    );
  }

  render() {
    const hayPropuesta = this.state.propuesta.length > 0;
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Importar Pedidos IMSS"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={[
            <ButtonItem
              key="descargarPlantilla"
              className="botonAgregar"
              icon={<DownloadOutlined />}
              onClick={descargarPlantilla}
            >
              Descargar plantilla
            </ButtonItem>,
            <Upload
              key="subirExcel"
              // El estado ya se avisa por message.success/error al terminar de leer;
              // mostrar la lista aqui, apretada en el header, se veia mal
              showUploadList={false}
              fileList={this.state.archivosExcel}
              customRequest={this.onChangeArchivo.bind(this)}
              accept=".xlsx,.xls"
            >
              <ButtonItem className="botonAgregar" azul icon={<UploadOutlined />}>
                Subir Excel del IMSS / ISSSTE
              </ButtonItem>
            </Upload>,
            <ButtonItem key="cancelar" className="botonAgregar" rojo onClick={this.atras.bind(this)}>
              Cancelar
            </ButtonItem>,
            <ButtonItem
              key="aceptar"
              className="botonAgregar"
              type="primary"
              azul
              onClick={() => this.formRef.current.submit()}
              disabled={
                !hayPropuesta ||
                this.state.diasSeleccionados.length === 0 ||
                this.state.guardando
              }
            >
              {`Aceptar y crear ${this.state.diasSeleccionados.length} pedido(s)`}
            </ButtonItem>,
          ]}
        />
        <div className="card-background" style={{ paddingTop: 5 }}>
          <Spin
            spinning={this.state.loading || this.state.guardando}
            tip={this.state.guardando ? "Creando los pedidos, no cierres la pantalla" : "Cargando"}
          >
            <Form
              ref={this.formRef}
              name="importarPedidosIMSS"
              layout
              initialValues={{ monedaId: MXN, tipoDeCambio: 1, contado: 1, diasCredito: 0 }}
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed.bind(this)}
            >
              <Row gutter={[16, 8]} style={{ marginTop: 10 }}>
                <Col xs={24} sm={24} md={12} lg={8}>
                  <FormItem label="Cliente" name="clienteId" margin required>
                    <SelectClientesItem
                      empresaId={this.props.empresaId}
                      headersToken={this.props.headersToken}
                      autoFocus
                      width="100%"
                      placeholder="Cliente"
                      onChange={(valueId, cliente) => this.onChangeCliente(valueId, cliente)}
                    />
                  </FormItem>
                </Col>
                <Col xs={24} sm={12} md={12} lg={8}>
                  <FormItem label="Fecha" name="fechaPedido" margin required initialValue={moment()}>
                    <DatePickerItem placeholder="Fecha" allowClear={false} />
                  </FormItem>
                </Col>
                <Col xs={24} sm={12} md={12} lg={8}>
                  <FormItem
                    label="Lunes de la semana"
                    name="fechaLunes"
                    margin
                    required
                    tooltip="De aqui salen las fechas de entrega de cada dia propuesto (los renglones con cantidad en dias de la semana). Cada fecha se puede ajustar despues en la tabla."
                    initialValue={moment().startOf("isoWeek")}
                  >
                    <DatePickerItem
                      placeholder="Lunes"
                      allowClear={false}
                      onChange={(fecha) => this.onChangeFechaLunes(fecha)}
                    />
                  </FormItem>
                </Col>

                <Col xs={24} sm={12} md={12} lg={8}>
                  <FormItem
                    label="Vendedor"
                    name="vendedorId"
                    margin
                    required
                    initialValue={this.props.usuarioId}
                  >
                    <SelectItem placeholder="Vendedor">{this.state.objetoUsuarios}</SelectItem>
                  </FormItem>
                </Col>
                <Col xs={24} sm={12} md={12} lg={8}>
                  <FormItem label="Proyecto" name="proyectoId" margin required>
                    <SelectItem placeholder="Proyecto" onChange={this.construirPropuesta}>
                      {this.state.objetoProyectos}
                    </SelectItem>
                  </FormItem>
                </Col>
                <Col xs={24} sm={12} md={12} lg={8}>
                  <FormItem label="Precio" name="precioId" margin required>
                    <SelectItem
                      placeholder="Precio"
                      disabled={!this.props.permisoModificarListaPreciosPedidos}
                      onChange={this.construirPropuesta}
                    >
                      {this.state.objetoPrecios}
                    </SelectItem>
                  </FormItem>
                </Col>

                <Col xs={24} sm={12} md={12} lg={8}>
                  <FormItem label="Metodo" name="contado" margin required>
                    <SelectItem width="100%" disabled={!this.props.permisoVenderCreditoPedidos}>
                      <Option value={1}>Contado - PUE</Option>
                      <Option value={2}>Credito - PPD</Option>
                    </SelectItem>
                  </FormItem>
                </Col>
                <Col xs={24} sm={12} md={12} lg={8}>
                  <FormItem noStyle shouldUpdate={(prev, curr) => prev.monedaId !== curr.monedaId}>
                    {({ getFieldValue }) => (
                      <>
                        <FormItem label="Moneda" name="monedaId" margin required>
                          <SelectItem
                            placeholder="Moneda"
                            onChange={(value) => this.onChangeMoneda(value)}
                          >
                            {this.state.objetoMonedas}
                          </SelectItem>
                        </FormItem>
                        {getFieldValue("monedaId") === MXN && (
                          <FormItem name="tipoDeCambio" hidden>
                            <InputNumberItem />
                          </FormItem>
                        )}
                      </>
                    )}
                  </FormItem>
                </Col>
                <Col xs={24} sm={12} md={12} lg={8}>
                  <FormItem noStyle shouldUpdate={(prev, curr) => prev.monedaId !== curr.monedaId}>
                    {({ getFieldValue }) =>
                      getFieldValue("monedaId") !== MXN ? (
                        <FormItem
                          label="T. Cambio"
                          name="tipoDeCambio"
                          margin
                          required
                          number
                          type="number"
                        >
                          <InputNumberItem
                            dinero
                            placeholder="T. Cambio"
                            onChange={this.construirPropuesta}
                          />
                        </FormItem>
                      ) : null
                    }
                  </FormItem>
                </Col>

                <Col xs={24} sm={12} md={12} lg={8}>
                  <FormItem noStyle shouldUpdate={(prev, curr) => prev.contado !== curr.contado}>
                    {({ getFieldValue }) =>
                      getFieldValue("contado") !== 1 ? (
                        <FormItem label="Dias de credito" name="diasCredito" margin required numberCero>
                          <InputNumberItem placeholder="Dias de Credito" />
                        </FormItem>
                      ) : null
                    }
                  </FormItem>
                </Col>
                <Col xs={24} sm={12} md={12} lg={8}>
                  <FormItem label="Uso CFDI" name="usoDeCfdiId" margin>
                    <SelectItem placeholder="Uso de CFDI">{this.state.objetoUsosDeCFDI}</SelectItem>
                  </FormItem>
                </Col>
                <Col xs={24} sm={12} md={12} lg={8}>
                  <FormItem label="Canal" name="canalDeVentaId" margin>
                    <SelectItem placeholder="Canal de Venta">
                      {this.state.objetoCanalesVenta}
                    </SelectItem>
                  </FormItem>
                </Col>
                <Col xs={24} sm={12} md={12} lg={8}>
                  <FormItem label="O Compra" name="ordenDeCompra" margin pattern>
                    <InputItem placeholder="Orden de Compra" />
                  </FormItem>
                </Col>
                <Col xs={24} sm={12} md={12} lg={8}>
                  <FormItem label="Req" name="req" margin pattern>
                    <InputItem placeholder="Requisicion" />
                  </FormItem>
                </Col>
                <Col xs={24} sm={12} md={12} lg={8}>
                  <FormItem label="Atencion a" name="atencion" margin pattern>
                    <InputItem placeholder="Atencion a" />
                  </FormItem>
                </Col>
                <Col xs={24} sm={24} md={24} lg={16}>
                  <FormItem
                    label="Observaciones"
                    name="observaciones"
                    margin
                    pattern
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                    tooltip="Leyenda general: se aplica a todos los pedidos propuestos, salvo a los que ya editaste individualmente en la tabla de abajo."
                  >
                    <TextAreaItem
                      placeholder="Observaciones para todos los pedidos"
                      autoSize
                      onChange={this.construirPropuesta}
                    />
                  </FormItem>
                </Col>
              </Row>
            </Form>

            {!this.state.analisis && (
              <Alert
                type="info"
                showIcon
                style={{ marginTop: 10 }}
                message="Como funciona"
                description='Descarga la plantilla, llenala y subela (no se acepta cualquier formato de Excel). Trae columnas de dia (LUNES...DOMINGO) y una columna MENSUAL: los renglones con cantidad en un dia arman el pedido de ese dia, y los que tengan cantidad en MENSUAL arman un pedido aparte con fecha "por definir". Un mismo renglon puede traer ambos. Los insumos se buscan en los Insumos por Cliente del cliente elegido y los precios salen del sistema, no del Excel.'
              />
            )}

            {this.renderResultados()}
            {this.renderPropuesta()}
          </Spin>
        </div>

        <ModalInsumoParaCliente
          visible={this.state.modalVincularVisible}
          onCancel={this.cerrarVincular.bind(this)}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          insumosYaConfigurados={this.state.insumoIdsCliente}
          valoresIniciales={
            this.state.filaAccion
              ? { nombreAlternativo: this.state.filaAccion.nombre, clave: this.state.filaAccion.clave }
              : undefined
          }
          onGuardar={this.guardarVinculo.bind(this)}
        />
        <ModalAltaInsumoImss
          visible={this.state.modalAltaVisible}
          onCancel={this.cerrarAlta.bind(this)}
          clienteId={this.state.clienteSeleccionado?._id}
          fila={this.state.filaAccion}
          onGuardado={this.onAltaGuardada.bind(this)}
        />
        <ModalConfirmarPedidosImss
          visible={this.state.modalConfirmarVisible}
          dias={this.state.propuesta.filter((dia) => this.state.diasSeleccionados.includes(dia.dia))}
          onChangeFecha={this.onChangeFechaDia.bind(this)}
          onCancel={this.cerrarModalConfirmar.bind(this)}
          onConfirmar={this.confirmarYCrearPedidos.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    insumosXClienteEmpresa: state.empresa.insumosXCliente,
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    usuarioId: state.user.usuarioId,
    permisoVenderCreditoPedidos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) => valueTodos.permisoId.toString() === "68a0b80d4319162f78ce6421"
      )?.activado,
    permisoModificarListaPreciosPedidos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) => valueTodos.permisoId.toString() === "68a0b80d4319162f78ce6427"
      )?.activado,
  };
};

export default connect(mapStateToProps)(ImportarPedidosIMSS);
